// "Where this stands" — shared rendering brains for a matter's dated
// timeline. Two consumers: the whereThisStands Alpine component (entity
// panels — email thread, job slideover, valuation tab — via
// shared/_where_this_stands.html.erb) and the dashboard review slide-over,
// which keeps its own template because it additionally injects the
// "this approval" row from the proposal being reviewed.
//
// Truth architecture: Alice authors dated rows; elapsed-day counts are NEVER
// authored — notes carry a {days} token that is expanded here, at render
// time, from the row's own date (a stalled matter doesn't re-sweep, so an
// authored "9 days" would still say 9 on day 16).

const MONTHS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']
const ESCAPES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }

export function timelineDaysSince(iso) {
  const [y, m, d] = String(iso).split('-').map(Number)
  const then = new Date(y, m - 1, d)
  const now = new Date()
  now.setHours(0, 0, 0, 0)
  return Math.max(0, Math.round((now - then) / 86400000))
}

export function timelineDateLabel(row) {
  if (row.kind === 'approval') return 'TODAY'
  const [y, m, d] = row.on.split('-').map(Number)
  return `${d} ${MONTHS[m - 1] || ''}`
}

export function timelineNoteHtml(row) {
  if (!row.note) return ''
  const escaped = row.note.replace(/[&<>"']/g, c => ESCAPES[c])
  return escaped.replace(/\{days\}/g, () => {
    const n = timelineDaysSince(row.on)
    return `<span class="font-mono text-[12px] text-[#B45309]">${n} day${n === 1 ? '' : 's'}</span>`
  })
}

// Valid rows, oldest first, each tagged past/future relative to today.
export function sortedTimeline(wi) {
  if (!wi || !Array.isArray(wi.timeline)) return []
  const today = new Date().toLocaleDateString('en-CA')
  return wi.timeline
    .filter(r => r && r.on && r.title)
    .map(r => ({ on: r.on, title: r.title, note: r.note, kind: r.on > today ? 'future' : 'past' }))
    .sort((a, b) => (a.on < b.on ? -1 : a.on > b.on ? 1 : 0))
}

// Alpine component behind shared/_where_this_stands.html.erb.
export function whereThisStands(wi) {
  return {
    wi,
    fullStory: false,
    get rows() { return sortedTimeline(this.wi) },
    get waitingDays() {
      return this.wi && this.wi.awaiting_since ? timelineDaysSince(this.wi.awaiting_since) : null
    },
    dateLabel: timelineDateLabel,
    noteHtml: timelineNoteHtml
  }
}
